import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import './SealCodes.scss';
import { useTranslation } from 'react-i18next';
import OnlineTestingService from '../OnlineTestingService';
import ChevronDown from 'assets/svgs/chevronDown.svg';
import ChevronUp from 'assets/svgs/chevronUp.svg';
import { AlertNotice } from 'shared/components';
import { ROOM_STATUS } from 'shared/constants';

const SealCodes = (props) => {
  const { t } = useTranslation();
  const { roomStatus, roomId, isNCRCRoom } = props;

  const [isExpanded, setIsExpanded] = useState(true);
  const [sealCodes, setSealCodes] = useState([]);
  const [message, setMessage] = useState(t('onlineTesting.sealCodes.closedRoom'));

  const getDisplayName = (code) => {
    if (isNCRCRoom && code.regType) {
      return code.regType;
    }
    return code.shortName;
  };

  const getSealCodes = useCallback(async () => {
    try {
      const codes = await OnlineTestingService.getSealCodes(roomId);
      setSealCodes(codes.data);
      if (!codes.data.length) {
        setMessage(t('onlineTesting.sealCodes.noSeals'));
      }
    } catch (error) {
      console.error('Failed to fetch seal codes:', error);
      setMessage(t('onlineTesting.sealCodes.errorSeals'));
      setSealCodes([]);
    }
  }, [roomId, t]);

  const setExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (roomStatus === ROOM_STATUS.opened) {
      getSealCodes();
    }
  }, [roomStatus, getSealCodes]);

  if (roomStatus === ROOM_STATUS.closed) {
    return null;
  }

  return (
    <Collapsible
      open={isExpanded}
      trigger={
        <div className="header-container" onClick={setExpand}>
          <div className="title">Seal codes</div>
          <div className="title status">
            <h6>{isExpanded ? 'Collapse' : 'Expand'}</h6>
            {isExpanded ? <ChevronUp /> : <ChevronDown />}
          </div>
        </div>
      }>
      {roomStatus !== ROOM_STATUS.opened || !sealCodes.length ? (
        <AlertNotice message={message} />
      ) : (
        <div className="codes-container">
          {sealCodes.map((code, idx) => (
            <div className="codes" key={idx}>
              <div className="code">
                {[...code.sealCode].map((seal, i) => (
                  <div className="individual-number" key={`${seal}-${i}`}>
                    {seal}
                  </div>
                ))}
              </div>
              <div className="test">{getDisplayName(code)}</div>
            </div>
          ))}
        </div>
      )}
    </Collapsible>
  );
};

export default SealCodes;

SealCodes.propTypes = {
  roomStatus: PropTypes.string.isRequired,
  roomId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isNCRCRoom: PropTypes.bool,
};
